import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { getPrettyCarrierName } from "@redotech/redo-web/carrier-service-labels";
import PackageIcon from "@redotech/redo-web/icon-old/package.svg";

// Exclude carrier variants that duplicate another carrier's display name
const excludedCarriers = new Set([
  Carriers.UPS_SUREPOST,
  Carriers.USPS_RETURNS,
  Carriers.USPS_SHIP,
  Carriers.FEDEX_SMART_POST,
  Carriers.UPS_MAIL_INNOVATIONS,
]);

export const SelectedCarrierFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "selectedCarrier",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "carrier",
  Icon: PackageIcon,
  values: Object.values(Carriers)
    .filter((c) => !excludedCarriers.has(c))
    .sort((a, b) => a.localeCompare(b)),
  display: (item: Carriers) => getPrettyCarrierName(item),
  displayName: "Selected carrier",
};
